$(function() {
    $('#employment').on('change', function() {
        if(this.value == 1){
            $('#show_info').prop('checked', true);
        }else{
            $('#show_info').prop('checked', false);
        }
    });
});


// WEBPACK FOOTER //
// ./resources/js/components/employee.js